import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { GlobalModule } from './global/global.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CurrencyPipe, DatePipe, DecimalPipe, PercentPipe, TitleCasePipe } from '@angular/common';
import { JwtModule } from '@auth0/angular-jwt';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { MAT_SELECT_CONFIG } from '@angular/material/select';

import { SharedModule } from './shared/shared.module';
import { MaterialModule } from 'src/app/material/material.module';
import { networkInterceptor } from './guards/networkInterceptor';
import { AuthGuardService } from './guards/auth-guard.service';
import { AuthModule } from './modules/auth/auth.module';
import { SocketNotificationComponent } from './web-socket/socket-notification/socket-notification.component';
import { SearchFilterModule } from './search-filter/search-filter.module';
import { ExternalInitializationComponent } from './external-initialization/external-initialization/external-initialization.component';
import { allComponents } from './layout/all.exports';
import { allServices } from './all.exports';
import { ManageHttpInterceptor } from 'src/app/services';

export function tokenGetter() {
  return localStorage.getItem('token');
}
@NgModule({
  declarations: [
    ...allComponents,
    AppComponent,
    SocketNotificationComponent,
    ExternalInitializationComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    GlobalModule,
    FormsModule,
    SharedModule,
    ReactiveFormsModule,
    HttpClientModule,
    MaterialModule,
    SearchFilterModule,
    // ToastrModule.forRoot({
    //   timeOut: 2000,
    //   positionClass: 'toast-bottom-right',
    //   preventDuplicates: true
    // }),
    JwtModule.forRoot({
      config: {
        tokenGetter: tokenGetter,

      }
    }),
    NgbModule,
    AuthModule,
    TranslateModule.forRoot({})
  ],
  exports: [GlobalModule],
  providers: [DatePipe, CurrencyPipe, PercentPipe, DecimalPipe, TitleCasePipe, AuthGuardService, {
    provide: HTTP_INTERCEPTORS,
    useClass: networkInterceptor,
    multi: true
  },
    // HttpCancelService,
    ...allServices,
    { provide: HTTP_INTERCEPTORS, useClass: ManageHttpInterceptor, multi: true },
    { provide: MAT_SELECT_CONFIG, useValue: { disableOptionCentering: 'false' } }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
